import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignIn, SignUp } from '@clerk/clerk-react';
import './AuthPage.css';

function safeRedirect(value) {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/trends';
  return value;
}

const AuthPage = ({ mode = 'signin' }) => {
  const [params] = useSearchParams();
  const redirect = safeRedirect(params.get('redirect_url'));
  const q = redirect !== '/trends'
    ? `?redirect_url=${encodeURIComponent(redirect)}`
    : '';

  return (
    <div className="auth-page">
      {mode === 'signin' ? (
        <SignIn
          routing="path"
          path="/signin"
          signUpUrl={`/signup${q}`}
          fallbackRedirectUrl={redirect}
        />
      ) : (
        <SignUp
          routing="path"
          path="/signup"
          signInUrl={`/signin${q}`}
          fallbackRedirectUrl={redirect}
        />
      )}
    </div>
  );
};

export default AuthPage;
